import color from "@constants/color";
import React, { useMemo, useRef } from "react";
import { View, TextInput, StyleSheet } from "react-native";
import Text from "@components/CustomText";

interface OTPInputProps {
  value: string;
  valueLength: number;
  onChange: (value: string) => void;
  otpText: string;
  error?: boolean;
}

const OTPInput: React.FC<OTPInputProps> = ({
  value,
  valueLength,
  onChange,
  otpText = "",
  error = false,
}) => {
  const itemsRef = useRef<Array<TextInput | null>>([]);

  const valueItems = useMemo(() => {
    const valueArray = value.split("");
    return Array.from({ length: valueLength }, (_, i) => valueArray[i] || "");
  }, [value, valueLength]);

  const handleKeyPress = (nativeEvent: any, idx: number) => {
    if (nativeEvent.key === "Backspace" && itemsRef.current[idx - 1]) {
      itemsRef.current[idx - 1]?.focus();
    }
  };

  const handleChange = (inputValue: string, idx: number) => {
    if (!/^\d+$/.test(inputValue) && inputValue !== "") return;

    const updatedValue =
      value.substring(0, idx) + inputValue + value.substring(idx + 1);
    onChange(updatedValue);

    if (inputValue && itemsRef.current[idx + 1]) {
      itemsRef.current[idx + 1]?.focus();
    }
  };

  return (
    <View style={styles.container}>
      <Text
        variant="body_text_4"
        style={{ textAlign: "center", marginBottom: 10 }}
      >
        {otpText}
      </Text>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        {valueItems.map((digit, index) => (
          <TextInput
            key={index}
            ref={(el) => (itemsRef.current[index] = el)}
            value={digit}
            style={[styles.input, error && styles.inputError]}
            maxLength={1}
            keyboardType="number-pad"
            textContentType="oneTimeCode"
            autoComplete="sms-otp"
            onChangeText={(val) => {
              if (error) {
                onChange("");
                itemsRef.current[0]?.focus();
              } else {
                handleChange(val, index);
              }
            }}
            onKeyPress={({ nativeEvent }) => handleKeyPress(nativeEvent, index)}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 20,
    backgroundColor: color.white,
    margin: 8,
    width: "95%",
    borderRadius: 10,
  },
  input: {
    borderColor: color.black,
    backgroundColor: "#F2F4FB",
    borderWidth: 0.5,
    borderRadius: 8,
    width: 48,
    height: 48,
    textAlign: "center",
    fontSize: 18,
    marginHorizontal: 5,
    fontWeight: "bold",
  },
  inputError: {
    backgroundColor: "#FFE5E5",
    borderColor: "#FF9999",
  },
});

export default OTPInput;
